import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Product from "./pages/Product";
import Search from "./pages/Search";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { ProductsProvider } from "./context/ProductsContext";
import { CartProvider, useCart  } from "./context/CartContext";
import { Toaster } from "react-hot-toast";
import FloatingCheckoutButton from "./components/FloatingCheckoutButton";
import Checkout from "./pages/Checkout";
import CartDrawer from "./components/CartDrawer";
import OrderSuccess from "./pages/OrderSuccess";
import PrivacyPolicy from "./components/PrivacyPolicy"

function AppContent() {
  const location = useLocation();  
  const { closeCart } = useCart();  
  const { cartOpen } = useCart();  // <--- SABEMOS SI EL CARRITO ESTÁ ABIERTO

useEffect(() => {
  closeCart();
}, [location.pathname]);

  // Detectar ruta actual
  const isCheckout = location.pathname === "/checkout";

  return (
    <>
      <Navbar />
      {/* 🔥 MUY IMPORTANTE → aquí va el Drawer */}
      <CartDrawer />

      <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          <Route path="/product/:id" element={<Product />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success" element={<OrderSuccess />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        </Routes>
      </main>

      <Footer />

      {/* 🚫 Ocultar si: estamos en checkout o el carrito está abierto */}
      {!isCheckout && !cartOpen && <FloatingCheckoutButton />}
    </>
  );
}

export default function App() {
  const [toastPosition, setToastPosition] = useState("top-right");

  useEffect(() => {
    const handleResize = () => {
      setToastPosition(window.innerWidth < 640 ? "top-center" : "top-right");
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="bg-white text-black font-sans">
        <CartProvider>
          <ProductsProvider>

            {/* Contenido principal */}
            <AppContent />

            {/* Toaster global */}
            <Toaster
              position={toastPosition}
              containerStyle={{
                marginTop: "125px",   // 🔥 mueve los toasts hacia abajo
              }}
              toastOptions={{
                duration: 2500,
                style: {
                  borderRadius: "12px",
                  background: "#1a1a1a",
                  color: "#fff",
                  fontWeight: "600",
                  padding: "14px 18px",
                  fontSize: "0.95rem",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
                },
                success: {
                  iconTheme: {
                    primary: "#e45f5a",
                    secondary: "#fff",
                  },
                },
              }}
            />

          </ProductsProvider>
        </CartProvider>
      </div>
    </Router>
  );
}
